export default {
      id: "icon-migrated-usage",
      viewBox: "0 0 20 18",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-migrated",
      toString: function () {
        return this.url;
      }
    }